import { Injector } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { ContentProvider } from '@awp/content';
import { take } from 'rxjs/operators';
var MenuHalService = /** @class */ (function () {
    function MenuHalService(injector) {
        var _this = this;
        this.injector = injector;
        this._content$ = new ReplaySubject(1);
        this.values = this._content$.asObservable();
        this.provider.get('navMenu.menuItems')
            .pipe(take(1))
            .subscribe(function (data) {
            var menuItems = data.map(function (p) {
                return {
                    name: p.name,
                    url: p.pageDetails.pageUrl,
                    parentUrl: p.pageDetails.parentUrl,
                    iconName: p.pageDetails.iconName,
                    hideInNav: p.pageDetails.hideInNav,
                    contentUrl: p._link != null && p._link.self != null ? p._link.self.href : null,
                    properties: p.pageProperties
                };
            });
            _this._content$.next(menuItems);
        });
    }
    Object.defineProperty(MenuHalService.prototype, "provider", {
        get: function () {
            if (this._contentProvider == null) {
                this._contentProvider = this.injector.get(ContentProvider);
            }
            return this._contentProvider;
        },
        enumerable: true,
        configurable: true
    });
    return MenuHalService;
}());
export { MenuHalService };
